import { FormEvent, useState } from 'react'
import { useMutation, gql } from '@apollo/client'

import { GraphQLError } from 'graphql'
import { UNKNOWN_ERROR } from '@/gf/providers/MsgsProvider'

import useMsgs from '@/gf/hooks/useMsgs'
import useToggle from '@/gf/hooks/useToggle'

import ModalForm from '@/gf/components/ModalForm'
import PercentInput from '@/gf/components/inputs/Percent'

const updateConvenienceFeeMutation = gql`
  mutation UpdateConvenienceFee($storeOrderId: String, $convenienceFeeRate: Decimal) {
    updateConvenienceFee(storeOrderId: $storeOrderId, convenienceFeeRate: $convenienceFeeRate) {
      id
    }
  }
`

const UpdateConvenienceFeeModal = ({
  open,
  onClose,
  onSaved,
  convenienceFee,
  storeOrderId,
}: {
  open: boolean
  onClose: () => void
  onSaved: (convenienceFeeRate: number) => void
  convenienceFee: number
  storeOrderId: string
}) => {
  const [_msgs, msgsMgr] = useMsgs()
  const [convenienceFeeRate, setConvenienceFeeRate] = useState<number>(convenienceFee)
  const [spinnerLive, spinner] = useToggle()
  const [updateConvenienceFee] = useMutation(updateConvenienceFeeMutation)

  const updateConvenienceFeeRate = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    spinner.on()

    updateConvenienceFee({
      variables: {
        storeOrderId,
        convenienceFeeRate,
      },
    })
      .then(() => {
        msgsMgr.add('Convenience Fee Updated!', 'positive')
        onSaved(convenienceFeeRate)
        onClose()
      })
      .catch((err: GraphQLError) => {
        msgsMgr.add(err.message || UNKNOWN_ERROR, 'negative')
      })
      .finally(spinner.off)
  }

  return (
    <ModalForm
      open={open}
      onClose={onClose}
      onSubmit={updateConvenienceFeeRate}
      submitButtonText="Save"
      submitButtonDisabled={spinnerLive}
      submitButtonShowSpinner={spinnerLive}
      title="Update Convenience Fee"
    >
      <div className="flex flex-col gap-4 py-6">
        <PercentInput
          value={convenienceFeeRate}
          setValue={(percent) => {
            if (percent || percent === 0) {
              setConvenienceFeeRate(percent)
            }
          }}
        />
      </div>
    </ModalForm>
  )
}

export default UpdateConvenienceFeeModal
